if (!customElements.get('jxs-announcement-bar')) {

  class JxsAnnouncementBar extends HTMLElement {
    constructor() {
      super()
      this.init()
    }

    init() {
      const multiItems = this.querySelectorAll('.splide__slide').length > 1
      const opt = {
        type: multiItems ? 'loop' : 'slide',
        perPage: 1,
        arrows: false,
        pagination: false
      }
      if (opt.type == 'loop' && this.hasAttribute('auto-play-sec')) {
        opt.autoplay = true
        opt.interval = parseInt(this.getAttribute('auto-play-sec')) * 1000
      }
      new Splide(this.querySelector('.splide'), opt).mount()
    }
  }


  customElements.define('jxs-announcement-bar', JxsAnnouncementBar)
}